import { Request } from '../request';
import { CreateTreatmentTemplateParams, GetVideoVisitTemplateParams } from 'types/treatmentTemplate';
import { TChartingPreferencePatch } from 'types/chartingPreference';

/**
 * 视频设置数据类型
 */
export interface ProviderKlarityMeetingRoomSetting {
    createAt?: string;
    createBy?: number;
    id?: number;
    meetingLinkGenerationType?: 'KLARITY_MEETING' | 'CUSTOM';
    providerId?: number;
    updateAt?: string;
    updateBy?: number;
}

/**
 * API响应类型
 */
export interface VideoSettingResponse {
    code: number;
    data: ProviderKlarityMeetingRoomSetting;
    message: string;
}

/**
 * 获取视频设置
 * @returns {Promise<VideoSettingResponse>} 视频设置数据
 */
export const getVideoSetting = () =>
    Request.get<VideoSettingResponse>({
        url: '/schedule-server/provider/video-setting/get',
    });

/**
 * 更新视频设置
 * @param {string} meetingLinkGenerationType - 会议链接生成类型，可选值：KLARITY_MEETING(自动生成)、CUSTOM(手动创建)
 * @returns {Promise<VideoSettingResponse>} 更新后的视频设置数据
 */
export const updateVideoSetting = (meetingLinkGenerationType: 'KLARITY_MEETING' | 'CUSTOM') => {
    const url = `/schedule-server/provider/video-setting/update?meetingLinkGenerationType=${meetingLinkGenerationType}`;
    return Request.post<VideoSettingResponse>({
        url,
        params: {},
    });
};

/**
 * 获取 charting 偏好（首次读取时后端按专科/付款方式初始化），返回 { current, defaults }
 */
export const getChartingPreference = () =>
    Request.get({
        url: '/schedule-server/provider/video-setting/charting/get',
    });

/**
 * 部分更新 charting 偏好：只改传入的 layout / section
 */
export const updateChartingPreference = (params: TChartingPreferencePatch) =>
    Request.post({
        url: '/schedule-server/provider/video-setting/charting/update',
        params,
    });

/**
 * 恢复为 provider 当前的默认值
 */
export const resetChartingPreference = () =>
    Request.post({
        url: '/schedule-server/provider/video-setting/charting/reset',
        params: {},
    });

export const getTreatmentTemplates = (params: GetVideoVisitTemplateParams) => {
    return Request.get({
        url: `/schedule-server/provider/treatment-plan/templates`,
        params,
    });
};

export const createTreatmentTemplate = (params: CreateTreatmentTemplateParams) => {
    return Request.post({
        url: `/schedule-server/provider/treatment-plan/templates`,
        params,
    });
};

export const updateTreatmentTemplate = (id: number, params: CreateTreatmentTemplateParams) => {
    return Request.put({
        url: `/schedule-server/provider/treatment-plan/templates/${id}`,
        params,
    });
};

export const deleteTreatmentTemplate = (id: number) => {
    return Request.delete({
        url: `/schedule-server/provider/treatment-plan/templates/${id}`,
    });
};

export const getTreatmentTemplateById = (id: number) => {
    return Request.get({
        url: `/schedule-server/provider/treatment-plan/templates/${id}`,
    });
};

export const copyTreatmentTemplate = (id: number) => {
    return Request.post({
        url: `/schedule-server/provider/treatment-plan/templates/${id}/copy`,
    });
};

export const getTreatmentTemplateCounts = (specialty: string) => {
    return Request.get({
        url: '/schedule-server/provider/treatment-plan/templates/service-type-count',
        params: {
            specialty,
        },
    });
};
